export default __webpack_public_path__ + "static/media/mnschedule_navicon.637edc5d.svg";